<div class="dialog-content-min-excel" style=" text-align: center !important; ">
    <div class="card">
        <h1>Download Excel Format</h1>
       <p> Please download this Excel Format. It will be saved in your Download directory by default. 
        Please check for the latest file that is downloaded since Excel does a version control if the file with the same name exists.
         Open the Excel file and enter the requested information in the columns provided.</p>
       </div>
</div>
<div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="closedpop()" ></p-button>
    <p-button class="m-1 w-full"   label="Download" styleClass="customesave" (click)="downloadFormat()" ></p-button>
 </div>
